import React from 'react';
import './ConsultationBanner.scss';
import ContactInfo from '../../../../Data/Contact';
import Init from '../../../../Init/Init';

const ConsultationBanner = () => {
    const { phoneno } = ContactInfo();
    const { FontAwesomeIcon } = Init;

    const waMessage = encodeURIComponent("Halo Admin Surya, saya ingin konsultasi kebutuhan kemasan di Yoboy Cup.");
    const waLink = `https://wa.me/${phoneno || '6285777592187'}?text=${waMessage}`;

    const scrollToCatalog = () => {
        const el = document.getElementById('packaging-catalog');
        if (el) {
            window.scrollTo({
                top: el.offsetTop - 80,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="consultation-section">
            <div className="consultation-card">
                {/* Background ambient flare/glow */}
                <div className="consultation-glow" />

                {/* Badge */}
                <div className="consultation-badge">
                    DUKUNGAN PENUH UNTUK BISNIS KOPI & MAKANANMU
                </div>

                {/* Title */}
                <h2 className="consultation-title">
                    Sudah Siap Upgrade Kemasanmu Jadi Lebih Keren?
                </h2>

                {/* Description */}
                <p className="consultation-desc">
                    Langsung cetak sekarang di Yoboy Cup, harga affordable dengan hasil cetakan terbaik! Butuh konsultasi dulu?
                </p>

                {/* CTA Buttons */}
                <div className="consultation-buttons">
                    <a 
                        href={waLink} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn-consult-wa"
                    >
                        <FontAwesomeIcon icon={['fab', 'whatsapp']} className="btn-icon" />
                        <span>Konsultasi via Whatsapp</span>
                    </a>

                    <button 
                        type="button" 
                        onClick={scrollToCatalog} 
                        className="btn-view-catalog"
                    >
                        <svg className="btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m12 3-9 5 9 5 9-5-9-5Z"></path>
                            <path d="m3 12 9 5 9-5"></path>
                            <path d="m3 17 9 5 9-5"></path>
                        </svg>
                        <span>Custom Sekarang / Order Cup Polosan</span>
                    </button>
                </div>

                {/* Trust Points */}
                <div className="consultation-trust-points">
                    <div className="trust-item">
                        <svg className="check-icon" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#FFC738" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <span>Biaya design hanya 1x per transaksi*</span>
                    </div>

                    <div className="trust-item">
                        <svg className="check-icon" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#FFC738" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <span>Garansi kepuasan pelanggan</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConsultationBanner;
